import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import {
    suppliesItemDetailRequest, consumeSuppliesItemRequest, consumeSuppliesItemRequestStatus,
    updateSuppliesItemStockRequest, updateSuppliesItemStockRequestStatus
} from '../../../redux/supplies/supplies.action'
import { displayErrorToast, displaySuccessToast, isEmpty, isNull } from "../../../utils/Utils";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import { API_CONSTANTS } from "../../../utils/AppConstants";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import Modal from 'react-bootstrap/Modal';
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import SubTextLabel from "../../../components/label/sub-text-label/subTextLabel";
import CommonCheckbox from "../../../components/common-checkbox/commonCheckbox";

const SuppliesItemDetail = props => {
    const { user } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { state } = useLocation()
    const { suppliesItemDetailSuccess, suppliesItemDetailError,
        consumeSuppliesItemSuccess, consumeSuppliesItemError, consumeSuppliesItemReqStatus,
        updateSuppliesItemStockSuccess, updateSuppliesItemStockError, updateSuppliesItemStockReqStatus } = useSelector(state => state.supplies)
    const [consumeQty, setConsumeQty] = useState('')
    const [showConsumeQtyModal, setShowConsumeQtyModal] = useState(false)
    const [stockQty, setStockQty] = useState('')
    const [sku, setSku] = useState('')
    const [cost, setCost] = useState('')
    const [perItemCost, setPerItemCost] = useState('')
    const [price, setPrice] = useState('')
    const [reorderThreshold, setReorderThreshold] = useState('')
    const [isSellable, setIsSellable] = useState(false)
    const [showUpdateStockModal, setShowUpdateStockModal] = useState(false)

    useEffect(() => {
        fetchItemDetail()
    }, [])

    const fetchItemDetail = () => {
        setLoading(true)
        dispatch(suppliesItemDetailRequest(state.suppliesId))
    }

    useEffect(() => {
        if (!isEmpty(suppliesItemDetailSuccess)) {
            setLoading(false)
            setSku(suppliesItemDetailSuccess.data.sku)
            setIsSellable(suppliesItemDetailSuccess.data.isSellable)
            setCost(suppliesItemDetailSuccess.data.cost)
            setPerItemCost(suppliesItemDetailSuccess.data.perItemCost)
            setPrice(suppliesItemDetailSuccess.data.price)
            setReorderThreshold(suppliesItemDetailSuccess.data.reorderThreshold)
        } else if (!isEmpty(suppliesItemDetailError)) {
            setLoading(false)
        }
    }, [suppliesItemDetailSuccess, suppliesItemDetailError])

    useEffect(() => {
        if (consumeSuppliesItemReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(consumeSuppliesItemSuccess.data?.message)
            fetchItemDetail()
            setConsumeQty('')
        } else if (consumeSuppliesItemReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(consumeSuppliesItemError.message)
        }
        if (consumeSuppliesItemReqStatus?.length) {
            dispatch(consumeSuppliesItemRequestStatus(''))
        }
    }, [consumeSuppliesItemSuccess, consumeSuppliesItemError, consumeSuppliesItemReqStatus])

    useEffect(() => {
        if (updateSuppliesItemStockReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(updateSuppliesItemStockSuccess.data?.message)
            fetchItemDetail()
            setStockQty('')
        } else if (updateSuppliesItemStockReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(updateSuppliesItemStockError.message)
        }
        if (updateSuppliesItemStockReqStatus?.length) {
            dispatch(updateSuppliesItemStockRequestStatus(''))
        }
    }, [updateSuppliesItemStockSuccess, updateSuppliesItemStockError, updateSuppliesItemStockReqStatus])

    const isPermissionAllowed = () => {
        return checkFunctionalityPermission(user, PERMISSION_TYPE.SUPPLIES, PERMISSION_SUB_TYPE.SUPPLIES.MANAGE_ITEM, parseFloat(state.businessId), parseFloat(state.locationId))
    }

    const getStatusClassname = (isActive) => {
        if (isActive === true) {
            return 'pd-status-container pd-status-container-complete'
        } else {
            return 'pd-status-container pd-status-container-cancelled'
        }
    }

    const handleConsumeSubmitClick = () => {
        if (isEmpty(consumeQty)) {
            displayErrorToast('Consumption quantity cannot be blank')
        } else if (parseFloat(consumeQty) <= 0) {
            displayErrorToast('Invalid consumption quantity')
        } else {
            setLoading(true)
            const data = {
                suppliesId: state.suppliesId,
                quantity: parseFloat(consumeQty)
            }
            dispatch(consumeSuppliesItemRequest(data))
            setShowConsumeQtyModal(false)
        }
    }

    const handleUpdateSubmitClick = () => {
        if (isEmpty(stockQty)) {
            displayErrorToast('Quantity cannot be blank')
        } else if (parseFloat(stockQty) <= 0) {
            displayErrorToast('Invalid quantity')
        } else if (isEmpty(sku)) {
            displayErrorToast('SKU cannot be blank')
        } else if (isEmpty(cost)) {
            displayErrorToast('Cost cannot be blank')
        } else if (parseFloat(cost) < 0) {
            displayErrorToast('Invalid cost')
        } else if (isEmpty(perItemCost)) {
            displayErrorToast('Per item cost cannot be blank')
        } else if (parseFloat(perItemCost) < 0) {
            displayErrorToast('Invalid per item cost')
        } else if (isSellable === true && isEmpty(price)) {
            displayErrorToast('Price cannot be blank')
        } else if (isSellable === true && parseFloat(price) < 0) {
            displayErrorToast('Invalid price')
        } else if (isEmpty(reorderThreshold)) {
            displayErrorToast('Reorder threshold cannot be blank')
        } else if (parseFloat(reorderThreshold) < 0) {
            displayErrorToast('Invalid reorder threshold')
        } else {
            setLoading(true)
            const data = {
                suppliesId: state.suppliesId,
                quantity: parseFloat(stockQty),
                cost: parseFloat(cost),
                perItemCost: parseFloat(perItemCost),
                sku: sku,
                isSellable: isSellable,
                reorderThreshold: reorderThreshold
            }
            if (isSellable === true) {
                data.price = price
            }
            dispatch(updateSuppliesItemStockRequest(data))
            setShowUpdateStockModal(false)
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Item Details' />
                {!isEmpty(suppliesItemDetailSuccess) && <CommonFormBorder>
                    <div className="pd-status-row-container">
                        <div className={getStatusClassname(suppliesItemDetailSuccess.data.isActive)}>{suppliesItemDetailSuccess.data.isActive ? 'Active' : 'In-Active'}</div>
                    </div>
                    <div className="pd-name-container">
                        <div className="pd-name-label">{suppliesItemDetailSuccess.data.name}</div>
                    </div>
                    <div className="pd-description-container">
                        <div className="pd-description-label">{suppliesItemDetailSuccess.data.description}</div>
                    </div>
                    {!isEmpty(suppliesItemDetailSuccess.data.suppliesCategoryDetail) && <div className="pd-icon-label">Category: {suppliesItemDetailSuccess.data.suppliesCategoryDetail.name}</div>}
                    {!isEmpty(suppliesItemDetailSuccess.data.sku) && <div className="pd-icon-label">SKU: {suppliesItemDetailSuccess.data.sku}</div>}
                    {!isEmpty(suppliesItemDetailSuccess.data.merchantDetail) && <div>
                        <FormFieldLabel label='Merchant Details' />
                        <div className="pd-icon-row-container">
                            <div className="pd-icon-container">
                                <img src={require('../../../assets/ic_user.png')} className="img" />
                            </div>
                            <div className="pd-icon-label">{suppliesItemDetailSuccess.data.merchantDetail.name}</div>
                        </div>
                        <FormFieldLabel label='Merchant Contact Person Details' />
                        <div className="pd-icon-row-container">
                            <div className="pd-icon-container">
                                <img src={require('../../../assets/ic_user.png')} className="img" />
                            </div>
                            <div className="pd-icon-label">{suppliesItemDetailSuccess.data.merchantDetail.contactPersonName}</div>
                        </div>
                        {!isEmpty(suppliesItemDetailSuccess.data.merchantDetail.contactPersonNumber) && <div className="pd-icon-row-container">
                            <div className="pd-icon-container">
                                <img src={require('../../../assets/ic_phone.png')} className="img" />
                            </div>
                            <div className="pd-icon-label">{suppliesItemDetailSuccess.data.merchantDetail.contactPersonNumber}</div>
                        </div>}
                        {!isEmpty(suppliesItemDetailSuccess.data.merchantDetail.contactPersonEmail) && <div className="pd-icon-row-container">
                            <div className="pd-icon-container">
                                <img src={require('../../../assets/ic_email.png')} className="img" />
                            </div>
                            <div className="pd-icon-label">{suppliesItemDetailSuccess.data.merchantDetail.contactPersonEmail}</div>
                        </div>}
                    </div>}
                    <div className="ad-purchase-parent-container">
                        <FormFieldLabel label='Stock Information' />
                        <div className="ad-purchase-row-container">
                            <div className="ad-purchase-row-item-container">Current Stock</div>
                            <div className="ad-purchase-row-item-container">{parseFloat(suppliesItemDetailSuccess.data.stock) <= 0 ? 'Out of Stock' : suppliesItemDetailSuccess.data.stock}</div>
                        </div>
                        <div className="ad-purchase-row-container">
                            <div className="ad-purchase-row-item-container">Reorder Threshold</div>
                            <div className="ad-purchase-row-item-container">{suppliesItemDetailSuccess.data.reorderThreshold}</div>
                        </div>
                        <div className="ad-purchase-row-container">
                            <div className="ad-purchase-row-item-container">Cost</div>
                            <div className="ad-purchase-row-item-container">{suppliesItemDetailSuccess.data.cost}</div>
                        </div>
                        <div className="ad-purchase-row-container">
                            <div className="ad-purchase-row-item-container">Per Item Cost</div>
                            <div className="ad-purchase-row-item-container">{suppliesItemDetailSuccess.data.perItemCost}</div>
                        </div>
                        {suppliesItemDetailSuccess.data.isSellable && <div className="ad-purchase-row-container">
                            <div className="ad-purchase-row-item-container">Price</div>
                            <div className="ad-purchase-row-item-container">{suppliesItemDetailSuccess.data.price}</div>
                        </div>}
                    </div>
                    {isPermissionAllowed() && <ButtonRow isVertical={true}>
                        <CommonButton label='Consume Stock' onClick={() => { setShowConsumeQtyModal(true) }} />
                        <CommonButton label='Update Stock' onClick={() => { setShowUpdateStockModal(true) }} />
                    </ButtonRow>}
                </CommonFormBorder>}
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowConsumeQtyModal(false) }}
                show={showConsumeQtyModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Consume Stock
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="scl-modal-form-container">
                        <SubTextLabel label='Enter quantity to consume' />
                        <CommonInputFloatFull
                            type='number'
                            id='consumeQty'
                            onChange={e => setConsumeQty(e.target.value)}
                            placeholder='Quantity'
                            value={consumeQty}
                        />
                        <ButtonRow>
                            <CommonButton label='Submit' onClick={() => { handleConsumeSubmitClick() }} />
                        </ButtonRow>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => { setShowUpdateStockModal(false) }}
                show={showUpdateStockModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Update Stock
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="scl-modal-form-container">
                        <SubTextLabel label='Enter details to update stock' />
                        <CommonInputFloatFull
                            type='number'
                            id='updateQty'
                            onChange={e => setStockQty(e.target.value)}
                            placeholder='Quantity'
                            value={stockQty}
                        />
                        <CommonInputFloatFull
                            type='text'
                            id='sku'
                            onChange={e => setSku(e.target.value)}
                            placeholder='SKU'
                            value={sku}
                        />
                        <CommonInputFloatFull
                            type='number'
                            id='cost'
                            onChange={e => setCost(e.target.value)}
                            placeholder='Cost'
                            value={cost}
                        />
                        <CommonInputFloatFull
                            type='number'
                            id='perItemCost'
                            onChange={e => setPerItemCost(e.target.value)}
                            placeholder='Per Item Cost'
                            value={perItemCost}
                        />
                        <CommonCheckbox
                            id='isSellable'
                            label='Is item sellable'
                            value={isSellable}
                            onChange={() => {
                                setIsSellable(!isSellable)
                            }}
                        />
                        {isSellable && <CommonInputFloatFull
                            type='number'
                            id='price'
                            onChange={e => setPrice(e.target.value)}
                            placeholder='Price'
                            value={price}
                        />}
                        <CommonInputFloatFull
                            type='number'
                            id='reorderThreshold'
                            onChange={e => setReorderThreshold(e.target.value)}
                            placeholder='Reorder Threshold'
                            value={reorderThreshold}
                        />
                        <ButtonRow>
                            <CommonButton label='Submit' onClick={() => { handleUpdateSubmitClick() }} />
                        </ButtonRow>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default SuppliesItemDetail